const regexes = {
  PIX_EMAIL:
    /^(?!.{77})([a-zA-Z0-9!#$&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/
};

export default regexes;
